import React from 'react';
import PropTypes from 'prop-types';

import GroupLockControls from '../common/GroupLockControls';
import MultiSelectionAlignControls from '../common/MultiSelectionAlignControls';
import SelectionCanvasAlignControls from '../common/SelectionCanvasAlignControls';
import {
  StyledMultiSelectionPanel,
  StyledMultiSelectionSection,
  StyledMultiSelectionSectionTitle,
} from './MultiSelectionOptions.styled';

const MultiSelectionOptions = ({ t }) => (
  <StyledMultiSelectionPanel className="respark_multi-selection-tool-options">
    <StyledMultiSelectionSection className="respark_multi-selection-section respark_multi-selection-section--group-lock">
      <GroupLockControls />
    </StyledMultiSelectionSection>
    <StyledMultiSelectionSection className="respark_multi-selection-section respark_multi-selection-section--align">
      <StyledMultiSelectionSectionTitle>
        {t('alignCanvasTitle')}
      </StyledMultiSelectionSectionTitle>
      <SelectionCanvasAlignControls />
      <StyledMultiSelectionSectionTitle>
        {t('multiAlignTitle')}
      </StyledMultiSelectionSectionTitle>
      <MultiSelectionAlignControls variant="sidebar" />
    </StyledMultiSelectionSection>
  </StyledMultiSelectionPanel>
);

MultiSelectionOptions.propTypes = {
  t: PropTypes.func.isRequired,
};

export default MultiSelectionOptions;
